import { AuthUI, useIsLoggedIn } from '@ekonavi/auth';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiEndpoint } from '../config';

export function Auth() {
  const navigate = useNavigate();
  const isLoggedIn = useIsLoggedIn();
  const wasLoggedInRef = useRef(isLoggedIn);
  
  // Listen for login state changes and redirect when user logs in
  useEffect(() => {
    // Only redirect if user just logged in (changed from false to true)
    if (!wasLoggedInRef.current && isLoggedIn) {
      navigate('/dashboard', { replace: true });
    }
    wasLoggedInRef.current = isLoggedIn;
  }, [isLoggedIn, navigate]);
  
  return (
		<div className='min-h-screen flex items-center justify-center bg-background'>
			<div className='w-full max-w-md'>
				<div className='text-center mt-8'>
					<h1 className='text-3xl font-bold text-foreground'>FAZ Admin</h1>
					<p className='text-muted-foreground mt-2'>Administration Portal</p>
				</div>
				<div className='rounded-lg p-6'>
					<AuthUI apiEndpoint={apiEndpoint} />
				</div>
			</div>
		</div>
	);
}